// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__crhPp","row":"ProcedureTreatmentSummary_row__2Hv1f"};